export const CONFIG_MUTATIONS = {
  SET_CONFIG: 'SET_CONFIG',
}

export const CONFIG_GETTERS = {
  IS_ZCM_ORIGIN: 'IS_ZCM_ORIGIN',
  IS_SDGS_ORIGIN: 'IS_SDGS_ORIGIN',
}
